module.exports = __webpack_public_path__ + "img/sankaku_19_red.6860b223.png";